import { Component } from '@angular/core';
import {UserModel} from "../../models/user.model";
import {PromotionModel} from "../../models/promotion.model";
import {Subscription} from "rxjs";
import {UserService} from "../../services/user.service";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {TitleService} from "../../services/title.service";
import {AuthService} from "../../services/auth.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {TrackingHelperService} from "../../services/tracking-helper.service";
import {GoogleAnalyticsService} from "ngx-google-analytics";
import {GameService} from "../../services/game.service";

@Component({
  selector: 'app-user-promotions',
  templateUrl: './user-promotions.component.html',
  styleUrls: ['./user-promotions.component.scss']
})
export class UserPromotionsComponent {

  // user!: UserModel | null;
  // promotions: PromotionModel[] = []
  // isLoading = true;

  promoUrl!: SafeResourceUrl | null;
  lang: string = 'en';


  // userSubs?: Subscription;
  // promoSubs?: Subscription;
  titleTranslateSubs?: Subscription;
  urlSubs?: Subscription;

  constructor(
    // private userService: UserService,
    private authService: AuthService,
    private translate: TranslateService,
    private titleService: TitleService,
    private sanitizer: DomSanitizer,
    private trackingService: TrackingHelperService,
    private gaService: GoogleAnalyticsService,
    private gameService: GameService,
  ) {
    this.titleTranslateSubs?.unsubscribe();
    this.titleTranslateSubs = this.translate.stream('PROMOTIONS.TITLE').subscribe(data => {
      this.titleService.setTitle(`Cashier / ${data}`);
    })

    try {
      this.lang = localStorage.getItem("lang") ?? 'en'
    } catch (error){
      console.warn('Error with localStorage:', error);
    }

    this.urlSubs?.unsubscribe();
    this.urlSubs = this.authService.cashierUrl.subscribe((url: string | null) => {
      if (url) {
        //disable chat in iframes
        url += '&chatButton=0'

        //add btag and tracker to url
        let bTag = this.trackingService.getBannerTag();
        if (bTag) {
          url += `&btag=${bTag}`
        }
        let t = this.trackingService.getTracker();
        if (t) {
          url += `&t=${t}&tracker=${t}`
        }
        let urlWithParams = this.updateUrlLangParam(this.updateUrlRouteParam(url), this.lang);
        this.promoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlWithParams);

        if (this.promoUrl){
          //opened page showing cashier
          this.gaService.event('cashier', undefined, undefined, undefined, undefined,{ cashier_visible: true, ...this.trackingService.getAffiliateOptions() });
        }
      }
    })

    // this.userSubs?.unsubscribe();
    // this.userSubs = this.userService.userObject.subscribe((u: UserModel | null) => {
    //   this.user = u;
    // })

    // this.promoSubs?.unsubscribe()
    // this.promoSubs = this.userService.getUserPromos().subscribe( data => {
    //   this.isLoading = false;
    //   // console.log(data.result.promotions)
    //   this.promotions = data.result.promotions;
    // })

  }

  updateUrlLangParam(url: string, lang:string){
    if(url.includes('lang')){
      return url.replace(/lang=[^&]*/, `lang=${lang}`);
    } else {
      return url + `&lang=${lang}`
    }
  }

  updateUrlRouteParam(url: string){
    if(url.includes('route')){
      return url.replace(/route=[^&]*/, 'route=promo');
    } else {
      return url + '&route=promo'
    }
  }


  ngOnDestroy(): void {
    // this.userSubs?.unsubscribe();
    // this.promoSubs?.unsubscribe();
    this.urlSubs?.unsubscribe();
    this.titleTranslateSubs?.unsubscribe();

    if (this.promoUrl){
      //closed page showing the cashier
      this.gaService.event('cashier', undefined, undefined, undefined, undefined,{ cashier_visible: false, ...this.trackingService.getAffiliateOptions() });

      //refetch games if the user did something with their promo ex. activated a promotion:
      // console.log('fetching games again')  //todo this is temporary - until we implement the promotions endpoint
      this.gameService.fetchGames()
    }
  }

}
